<template>
  <div :class="`${className}__categories${!careServiceWizardIsFinished ? ' is-error' : ''}`">
    <div
      v-for="(item, idx) in categories()"
      :key="`categories-${idx}`"
      :class="`${className}__catItem`"
    >
      <Icon :name="icons[idx]" :class="`${className}__catImage`" color="primaryBlue" />
      <div>
        <Copy
          :staticClass="`${className}__catHeadline`"
          element="div"
          color="primaryBlue"
          size="l"
          bold
        >
          <span v-html="item.headline" />
        </Copy>
        <template v-if="item.support || item.support >= 0">
          <Copy element="div">{{ $t(`cs.analysis.cat.support.${item.support}`) }}</Copy>
          <Copy element="div" bold>
            {{ $t(`cs.analysis.cat.activities.${item.activities}`) }}
          </Copy>
        </template>
        <Copy v-else element="div">{{ $t('cs.analysis.cat.notUsed') }}</Copy>
      </div>
      <Icon
        color="primaryBlue"
        name="pencil-line"
        :class="`${className}__catIcon`"
        size="l"
        :onClick="() => onClick(idx, item.headline)"
      />
    </div>

    <div v-if="!careServiceWizardIsFinished" :class="`${className}__layer`">
      <Copy centered bold>{{ $t('cs.analysis.cat.error.headline') }}</Copy>
      <Copy centered>
        {{ $t('cs.analysis.cat.error.copy') }}
      </Copy>
    </div>
  </div>
</template>

<script>
import Icon from '@/objects/Icon';
import Copy from '@/objects/Copy';
import careServiceContent from '@/content/services/CareService/CareService';

import { ROUTE_SERVICE_PFLEGELEISTUNGSFINDER } from '@/constants/routes';

import mixin from '@/mixins/careService';

export default {
  components: {
    Copy,
    Icon,
  },
  mixins: [mixin],
  props: {
    className: String,
  },
  data() {
    return {
      icons: ['illu-handshake', 'illu-user', 'illu-home', 'illu-heart'],
    };
  },
  methods: {
    categories() {
      const contents = [];
      let i = 0;
      careServiceContent.map((cs) => {
        if (cs.component.name === 'SwitcherRow') {
          const { image, headline } = cs.component.props;

          let obj = {};
          if (this.careService[`switcherRow-${i}`]) {
            obj.support = this.careService[`switcherRow-${i}`][0];
            obj.activities = this.careService[`switcherRow-${i}`][1];
          }
          contents.push({
            image,
            headline,
            ...obj,
          });
          i++;
        }
      });
      return contents;
    },

    onClick(idx, headline) {
      if (this.careServiceWizardIsFinished) {
        this.$router.push(`${ROUTE_SERVICE_PFLEGELEISTUNGSFINDER}/${idx + 1}?mode=edit`);
        this.$emit('onTrackingClick', '-Fragebogen-Bearbeiten_click-bearbeiten_' + headline);
      }
    },
  },
};
</script>
